export const steps = ["Add Admins", "Apply Configurations"];

export const initilLog = [
	{ name: "Create Admin Users" },
	{
		name: "Destroy default admin",
		tasks: [{ firstName: "admin", lastName: "", email: "admin@altimetrik.com" }]
	}
];
